export default __webpack_public_path__ + "static/media/friends.139a01e8.png";